import React from "react";
import AppButton from "../../../../components/AppButton";
import AppCard from "../../../../components/AppCard";
import AppCardBody from "../../../../components/AppCardBody";
import AppCardFooter from "../../../../components/AppCardFooter";
import AppCardHeader from "../../../../components/AppCardHeader";
import AppLink from "../../../../components/AppLink";
import { IconForm, IconSubject } from "../../../../icons";
import DocsNiceToKnow from "../../shared/DocsNiceToKnow";
import DocsPreviewPanel from "../../shared/DocsPreviewPanel";
import DocsSectionCard from "../../shared/DocsSectionCard";

const cardContainerNotes = [
  "AppCard ist nur der Container der Card.",
  "AppCard bringt Border, Radius, Background und Overflow.",
  "Innenabstände kommen erst von CardHeader, CardBody, CardFooter oder lokalem Inhalt.",
];

const cardStructureNotes = [
  "Header, Body und Footer sind optionale Zonen innerhalb von AppCard.",
  'Body inset="none" ist bleed und geht über die volle Card-Breite.',
  'Body inset="default" folgt der normalen Lesekante der Card.',
  "Footer liegt ausserhalb des Bodys und kann bei scrollendem Body sichtbar bleiben.",
];

function PreviewLabel({ children }) {
  return <div className="ds-docs-card-proposal__label">{children}</div>;
}

function SurfaceFact({ label, value }) {
  return (
    <div className="ds-docs-card-proposal__surface-fact">
      <span>{label}</span>
      <strong>{value}</strong>
    </div>
  );
}

export default function CardsDocs() {
  return (
    <DocsSectionCard title="Cards">
      <div className="ds-docs-card-proposal">
        <div className="ds-docs-spotlight-grid ds-docs-spotlight-grid--cards-proposal">
          <DocsPreviewPanel>
            <div className="ds-docs-preview-surface ds-docs-card-proposal__surface-preview">
              <AppCard className="ds-docs-card-proposal__empty-card">
                <div className="ds-docs-card-proposal__empty-card-content">
                  <div className="ds-docs-card-proposal__empty-card-label">AppCard</div>
                  <p>Nicht als komplette Inhaltskomponente verstehen. AppCard ist nur die Hülle.</p>
                </div>
              </AppCard>

              <div className="ds-docs-card-proposal__surface-facts" aria-label="AppCard Aufbau">
                <SurfaceFact label="Border" value="default" />
                <SurfaceFact label="Radius" value="md" />
                <SurfaceFact label="Background" value="white" />
                <SurfaceFact label="Overflow" value="hidden" />
                <SurfaceFact label="Innenabstand" value="kommt später" />
              </div>
            </div>
          </DocsPreviewPanel>

          <DocsNiceToKnow items={cardContainerNotes} />
        </div>

        <div className="ds-docs-spotlight-grid ds-docs-spotlight-grid--cards-proposal">
          <DocsPreviewPanel>
            <div className="ds-docs-preview-surface ds-docs-card-proposal__structure-preview">
              <div className="ds-docs-card-proposal__build-grid">
                <div className="ds-docs-card-proposal__structure-card-wrap">
                  <PreviewLabel>Aufbau</PreviewLabel>
                  <AppCard className="ds-docs-card-proposal__zone-card">
                    <div className="ds-docs-card-proposal__zone-stack">
                      <div className="ds-docs-card-proposal__zone-block ds-docs-card-proposal__zone-block--header">
                        AppCardHeader
                      </div>
                      <div className="ds-docs-card-proposal__zone-block ds-docs-card-proposal__zone-block--body-bleed">
                        AppCardBody bleed
                      </div>
                      <div className="ds-docs-card-proposal__zone-block ds-docs-card-proposal__zone-block--body-inset">
                        AppCardBody inset
                      </div>
                      <div className="ds-docs-card-proposal__zone-block ds-docs-card-proposal__zone-block--footer">
                        AppCardFooter
                      </div>
                    </div>
                  </AppCard>
                </div>

                <div className="ds-docs-card-proposal__structure-card-wrap">
                  <PreviewLabel>Bleed / Inset</PreviewLabel>
                  <AppCard className="ds-docs-card-proposal__example-card">
                    <AppCardHeader
                      title="Card Title"
                      subtitle="Card Subtitle"
                      action={
                        <AppButton variant="muted" size="sm">
                          Action
                        </AppButton>
                      }
                    />
                    <AppCardBody inset="none">
                      <div className="ds-docs-card-proposal__bleed-body">
                        Bleed body: geht über die volle Card-Breite.
                      </div>
                    </AppCardBody>
                    <AppCardBody>
                      <div className="ds-docs-card-proposal__inset-body">
                        Inset body: folgt der normalen Lesekante der Card.
                      </div>
                    </AppCardBody>
                    <AppCardFooter>
                      <AppLink href="#" onClick={(event) => event.preventDefault()} size="sm">
                        Footer-Link
                      </AppLink>
                    </AppCardFooter>
                  </AppCard>
                </div>
              </div>

              <div className="ds-docs-card-proposal__structure-card-wrap">
                <PreviewLabel>Header-Typen</PreviewLabel>
                <div className="ds-docs-card-proposal__header-strip">
                  <AppCard>
                    <AppCardHeader title="Default Header" subtitle="grösserer Titel" visual={<IconForm />} />
                  </AppCard>
                  <AppCard>
                    <AppCardHeader
                      title="Compact Header"
                      subtitle="kleinerer Titel"
                      titleVariant="compact"
                      visual={<IconSubject />}
                    />
                  </AppCard>
                </div>
              </div>
            </div>
          </DocsPreviewPanel>

          <DocsNiceToKnow items={cardStructureNotes} />
        </div>
      </div>
    </DocsSectionCard>
  );
}
